<div
    [ngClass]="{'audit-grid': (mode=='viewRuleAudit' && viewAuditRuleArr && viewAuditRuleArr.length>=0) ? true : false}">
    <div class="audit-grid-history-c" *ngIf="mode=='viewRuleAudit' && viewAuditRuleArr && viewAuditRuleArr.length==0">
        <nz-empty *ngIf="!viewAuditRuleArr.length && viewRuleArr.length" [nzNotFoundContent]="viewRuleArr[0]?.displayName"
            [nzNotFoundFooter]="'Version history data not found'"></nz-empty>
    </div>
    <div class="audit-grid-history-c" *ngIf="viewAuditRuleArr && viewAuditRuleArr.length>0">
        <h3 class="m-b-25"></h3>
        <nz-timeline class="cp-f">
            <nz-timeline-item *ngFor="let i of viewAuditRuleArr" [nzColor]="i.tagColor||'grey'" class="tl-audit-item">
                <h4 class="f-w-400 f-s-1r" class="tl-audit-item-selected" (click)="getRuleHistoryData(i,i?.entityVersionId)">
                    {{i.entityName || '-'}}
                    <nz-tag *ngIf="(i.id == selectedItem.id)" [nzColor]="'green'">Current</nz-tag>
                </h4>
                <p><i nz-icon nzType="calendar"></i> {{convertTimestampToRegular(i.updatedDt)}}</p>
                <p>
                    <strong class="d-b">Remarks:</strong>
                    <!-- {{(i.remarks) || '-'}} -->
                    <span *ngIf="i.remarks">
                        <p>
                            {{i.remarks}}
                        </p>
                    </span>
                    <span *ngIf="!i.remarks" class="nodatafound">
                        No data found
                    </span>
                </p>
                <p>
                    <strong>User: </strong>
                    <!--<span class="d-i-b m-l-r-10 d-0"><nz-avatar nzSize="small" nzIcon="user"></nz-avatar></span>-->
                    {{(i.updatedUser | technicalTranslate) || '-'}}
                </p>
            </nz-timeline-item>
        </nz-timeline>
    </div>
    <!-- <div *ngIf="!viewAuditRuleArr.length" class="audit-grid-history-c">
        <nz-empty *ngIf="!viewAuditRuleArr.length"></nz-empty>
    </div> -->

    <div class="audit-grid-info-c" style="min-width: 100%" *ngIf="viewRuleArr && viewRuleArr.length">
        <!-- RULE INFORMATION RENDERING (MAKE SEPARATE DYNAMIC COMPONENT) -->
        <nz-spin [nzSpinning]="isLoading">
            <div>
                <!-- Head -->
                <div *ngIf="(showDetails === true || showDetails === undefined)">
                <h3 *ngIf="false" class="f-w-700 f-s-1-4r tl-audit-item-selected m-b-25">
                    {{(viewRuleArr[0]?.displayName ) || '-'}}
                    <!-- <small class="d-i-b p-r-10">(REVISION {{selectedItem.revision}})</small> -->
                    <!-- <nz-tag *ngIf="selectedItem.tag" [nzColor]="selectedItem.tagColor">{{selectedItem.tag}}</nz-tag> -->
                    <nz-tag *ngIf="viewRuleArr[0]?.productFamilyCSV" [nzColor]="'blue'" nz-tooltip nzTooltipTitle="'The product line field identifies the specific line of business, such as Health, to which the rule belongs. It helps align the rule with the appropriate product context.'">
                        {{(viewRuleArr[0]?.productFamilyCSV | technicalTranslate) || '-'}}
                        <span class="p-l-5 col-grey-light cur-pointer">
                            <i nz-icon nzType="exclamation-circle" class="ico-item"></i>
                        </span>
                    </nz-tag>
                    <nz-tag *ngIf="mode!='viewRule'" [nzColor]="'green'">Current</nz-tag>
                </h3>
                <div *ngIf="mode!='viewRule';else viewRuleTitle" class="">
                    <app-card-title [cardTitle]="'Rule Summary'" [entityName]="(viewRuleArr[0]?.displayName ) || '-'" [logo]="'file-done'" [tags]="tags" [auditStatus]="'Current'"></app-card-title>
                </div>
                <ng-template #viewRuleTitle>
                    <app-card-title [cardTitle]="'Rule Summary'" [entityName]="(viewRuleArr[0]?.displayName ) || '-'" [logo]="'file-done'" [tags]="tags"></app-card-title>
                </ng-template>
                <div [hidden]="privilege && privilege == 'VIEW' && viewRuleArr[0]?.ruleDesc == null">
                    <span *ngIf="viewRuleArr[0]?.ruleDesc" class="hoverable-input"><i>{{viewRuleArr[0]?.ruleDesc}}</i></span>
                </div>
            </div>
                <br>
                <!-- Summary -->

                <!-- View Mode block -->
                <ng-container *ngIf="mode === 'viewRule' && (showDetails === true || showDetails === undefined)">                
                <div *ngFor="let item of viewRuleArr || []; let lastItem = last;">
                    <div class="view-data-section">
                        <h2 class="heading-mms" style="background: #f6f6f6;
                        padding: 10px;">
                            <span class="p-r-10" nz-icon nzType="down-circle" [nzSize]="'default'" [nzRotate]="isCollapsed ? 180 : 0" (click)="isCollapsed = !isCollapsed"></span>Rule Details</h2>
                        <div *ngIf="!isCollapsed" class="grid grid-3x grid-3x-responsive">
                            <!-- <div>
                                <span class="s-c-heading">Product Line</span>
                                {{(item.productFamilyCSV | technicalTranslate) || '-'}}
                            </div> -->
                            <!-- <div>
                                <span class="s-c-heading">Rule Name</span>
                                {{(item.displayName) || '-'}}
                            </div> -->
                            <div>
                                <span class="s-c-heading">Version
                                    <span class="p-l-5 col-grey-light cur-pointer" nz-tooltip nzTooltipTitle="The version field maintains different versions of the rule, allowing for easy tracking and management of rule changes over time.">
                                        <i nz-icon nzType="exclamation-circle" class="ico-item"></i>
                                      </span>
                                </span>
                                {{(item.versionId) || '-'}}
                            </div>
                            <div>
                                <span class="s-c-heading">Rule Purpose
                                    <span class="p-l-5 col-grey-light cur-pointer" nz-tooltip nzTooltipTitle="This field captures the purpose of the rule based on the product line. It allows for the selection of multiple purposes, enabling precise rule definition tailored to specific product requirements.">
                                        <i nz-icon nzType="exclamation-circle" class="ico-item"></i>
                                    </span>
                                </span>
                                {{(item.service | technicalTranslate) || '-'}}
                            </div>
                            <div>
                                <span class="s-c-heading">Rule Type
                                    <span class="p-l-5 col-grey-light cur-pointer" nz-tooltip nzTooltipTitle="This field specifies the type of rule being defined, such as Eligibility Rule, Payout Rule, Adjudication Rule, etc. It helps categorize and organize rules based on their purpose.">
                                        <i nz-icon nzType="exclamation-circle" class="ico-item"></i>
                                      </span>
                                </span>
                               {{(item.ruleType | technicalTranslate: 'serviceTypeCd') || '-'}}
                            </div>
                            <!--  -->
                            <div>
                                <span class="s-c-heading">Rule Category</span>
                                {{(item.ruleCategory | technicalTranslate) || '-'}}
                            </div>
                            <!--  -->
                            <div>
                                <span class="s-c-heading">Rule Applicability
                                    <span class="p-l-5 col-grey-light cur-pointer" nz-tooltip nzTooltipTitle="Click to view details" (click)="showDetailedDesc('Rule Applicability' , fieldDescriptions['ruleApplicability'])">         
                                        <i nz-icon nzType="question-circle" class="ico-item"></i>
                                    </span>
                                </span>
                                {{(item.ruleSetType | technicalTranslate) || '-'}}
                            </div>
                            <div *ngIf="item.ruleSetType == 'ENTITY_PRODUCT_SET'">
                                <span class="s-c-heading">Product
                                    <span class="p-l-5 col-grey-light cur-pointer" nz-tooltip nzTooltipTitle="Field for capturing product name for which this rule is applicable.">
                                        <i nz-icon nzType="exclamation-circle" class="ico-item"></i>
                                      </span>
                                </span>
                                {{(item.productName  | technicalTranslate : 'prdBasePlanCd') || '-'}}
                            </div>
                            <div>
                                <span class="s-c-heading">Rule Level
                                    <span class="p-l-5 col-grey-light cur-pointer" nz-tooltip nzTooltipTitle="This read-only field indicates the level of the rule, providing information about its hierarchy or position within the rule structure.">
                                        <i nz-icon nzType="exclamation-circle" class="ico-item"></i>
                                      </span>
                                </span>
                                {{(item.ruleEntity | technicalTranslate) || '-'}}
                            </div>
                            <div>
                                <span class="s-c-heading">Valid From
                                    <span class="p-l-5 col-grey-light cur-pointer" nz-tooltip nzTooltipTitle="The effective date determines when the rule becomes applicable. It is typically compared with the proposal signed date on the transaction to ensure the rule is implemented correctly.">
                                        <i nz-icon nzType="exclamation-circle" class="ico-item"></i>
                                      </span>
                                </span>
                                {{item.fromDate ? (convertTimestampToRegular(item.fromDate) | date: appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR) : '-'}}
                            </div>
                            <div>
                                <span class="s-c-heading">Valid To
                                    <span class="p-l-5 col-grey-light cur-pointer" nz-tooltip nzTooltipTitle="The expiry date marks the point from which the rule will no longer be applicable. It helps manage rule validity and ensures that outdated rules are not enforced.">
                                        <i nz-icon nzType="exclamation-circle" class="ico-item"></i>
                                    </span>
                                </span>
                                {{item.toDate ? (convertTimestampToRegular(item.toDate) | date: appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR) : '-'}}
                            </div>
                            <!--  -->
                            <div>
                                <span class="s-c-heading">Overridden Rule</span>
                                {{(item.baseRule) || '-'}}
                            </div>
                            <div *ngIf="item.category">
                                <span class="s-c-heading">Rule Priority</span>
                                {{(item.category | technicalTranslate) || '-'}}
                            </div>
                            <!-- <div *ngIf="item.decisionType">
                                <span class="s-c-heading">Decision Type
                                    <span class="p-l-5 col-grey-light cur-pointer" nz-tooltip nzTooltipTitle="The description field provides a clear and detailed explanation of the rule. It helps in understanding the purpose, logic, and conditions of the rule.">
                                        <i nz-icon nzType="exclamation-circle" class="ico-item"></i>
                                      </span>
                                </span>
                                {{(item.decisionType | technicalTranslate) || '-'}}
                            </div> -->
                            <div *ngIf="item.ruleProcessingType">
                                <span class="s-c-heading">Processing Type
                                    <span class="p-l-5 col-grey-light cur-pointer" nz-tooltip nzTooltipTitle="Click to view details" (click)="showDetailedDesc('Processing Type' , fieldDescriptions['ruleProccessingType'])">         
                                        <i nz-icon nzType="question-circle" class="ico-item"></i>
                                    </span>
                                </span>
                                {{(item.ruleProcessingType | technicalTranslate) || '-'}}
                            </div>
                            <div *ngIf="item.preConditionRuleCSV && selectedPreConditionRule && selectedPreConditionRule.displayName">
                                <span class="s-c-heading">Pre-condition Rule</span>
                                {{selectedPreConditionRule.displayName || '-'}}
                            </div>
                              <!--  -->
                              <div style="grid-column: 1/4;">
                                <span class="s-c-heading">Rule Description
                                    <span class="p-l-5 col-grey-light cur-pointer" nz-tooltip nzTooltipTitle="The description field provides a clear and detailed explanation of the rule. It helps in understanding the purpose, logic, and conditions of the rule.">
                                        <i nz-icon nzType="exclamation-circle" class="ico-item"></i>
                                      </span>
                                </span>
                                {{(item.ruleDesc) || '-'}}
                            </div>
                            <!--  -->
                        </div>

                        <!-- <div><span class="s-c-heading">Rule Entity</span>{{item.ruleEntity | technicalTranslate}}</div> -->
                        <!-- <div>
                            <span class="s-c-heading">Rule Sub Type</span>
                            {{(item.ruleSubType | technicalTranslate) || '-'}}
                        </div> -->
                        

                        
                        <!-- <div>
                            <span class="s-c-heading">Rule Set Type</span>
                            {{(item.ruleSetType | technicalTranslate) || '-'}}
                        </div> -->
                    </div>
                    <nz-divider *ngIf="!lastItem"></nz-divider>
                </div>
            </ng-container>

                <!-- Audit Mode block -->
                <ng-container *ngIf="mode=='viewRuleAudit'">
                    <div *ngFor="let item of viewRuleArr || []; let lastItem = last;">
                        <div (click)="isCollapsed = !isCollapsed" class="view-data-section">
                            <h2 class="heading-mms" style="background: #f6f6f6;
                        padding: 10px;">
                            <span class="p-r-10" nz-icon nzType="down-circle" [nzSize]="'default'" [nzRotate]="isCollapsed ? 180 : 0"></span>Rule Details</h2>
                            <div *ngIf="!isCollapsed" class="grid grid-3x grid-3x-responsive">
                                <!-- <div>
                                    <span class="s-c-heading">Product Line</span>
                                    {{(item.productFamilyCSV | technicalTranslate) || '-'}}
                                </div> -->
                                <!-- <div>
                                    <span class="s-c-heading">Rule Name</span>
                                    {{(item.displayName) || '-'}}
                                </div> -->
                                <div>
                                    <span class="s-c-heading">Version
                                        <span class="p-l-5 col-grey-light cur-pointer" nz-tooltip
                                            nzTooltipTitle="The version field maintains different versions of the rule, allowing for easy tracking and management of rule changes over time.">
                                            <i nz-icon nzType="exclamation-circle" class="ico-item"></i>
                                        </span>
                                    </span>
                                    {{(item.versionId) || '-'}}
                                </div>
                                <div>
                                    <span class="s-c-heading">Rule Purpose
                                        <span class="p-l-5 col-grey-light cur-pointer" nz-tooltip nzTooltipTitle="This field captures the purpose of the rule based on the product line. It allows for the selection of multiple purposes, enabling precise rule definition tailored to specific product requirements.">
                                            <i nz-icon nzType="exclamation-circle" class="ico-item"></i>
                                        </span>
                                    </span>
                                    {{(item.service | technicalTranslate) || '-'}}
                                </div>
                                <div>
                                    <span class="s-c-heading">Rule Type
                                        <span class="p-l-5 col-grey-light cur-pointer" nz-tooltip
                                            nzTooltipTitle="This field specifies the type of rule being defined, such as Eligibility Rule, Payout Rule, Adjudication Rule, etc. It helps categorize and organize rules based on their purpose.">
                                            <i nz-icon nzType="exclamation-circle" class="ico-item"></i>
                                        </span>
                                    </span>
                                    {{(item.ruleType | technicalTranslate) || '-'}}
                                </div>
                                <!--  -->
                                <div>
                                    <span class="s-c-heading">Rule Category</span>
                                    {{(item.ruleCategory | technicalTranslate) || '-'}}
                                </div>
                                <!--  -->
                                <div>
                                    <span class="s-c-heading">Rule Applicability
                                        <span class="p-l-5 col-grey-light cur-pointer" nz-tooltip nzTooltipTitle="Click to view details"
                                            (click)="showDetailedDesc('Rule Applicability' , fieldDescriptions['ruleApplicability'])">
                                            <i nz-icon nzType="question-circle" class="ico-item"></i>
                                        </span>
                                    </span>
                                    {{(item.ruleSetType | technicalTranslate) || '-'}}
                                </div>
                                <div *ngIf="item.ruleSetType == 'ENTITY_PRODUCT_SET'">
                                    <span class="s-c-heading">Product
                                        <span class="p-l-5 col-grey-light cur-pointer" nz-tooltip
                                            nzTooltipTitle="Field for capturing product name for which this rule is applicable.">
                                            <i nz-icon nzType="exclamation-circle" class="ico-item"></i>
                                        </span>
                                    </span>
                                    {{(item.productName  | technicalTranslate : 'prdBasePlanCd') || '-'}}
                                </div>
                                <div>
                                    <span class="s-c-heading">Rule Level
                                        <span class="p-l-5 col-grey-light cur-pointer" nz-tooltip
                                            nzTooltipTitle="This read-only field indicates the level of the rule, providing information about its hierarchy or position within the rule structure.">
                                            <i nz-icon nzType="exclamation-circle" class="ico-item"></i>
                                        </span>
                                    </span>
                                    <span>{{(item.ruleEntity | technicalTranslate) || '-'}}</span>
                                </div>
                                <div>
                                    <span class="s-c-heading">Valid From
                                        <span class="p-l-5 col-grey-light cur-pointer" nz-tooltip
                                            nzTooltipTitle="The effective date determines when the rule becomes applicable. It is typically compared with the proposal signed date on the transaction to ensure the rule is implemented correctly.">
                                            <i nz-icon nzType="exclamation-circle" class="ico-item"></i>
                                        </span>
                                    </span>
                                    {{item.fromDate ? (convertTimestampToRegular(item.fromDate) | date: appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR) : '-'}}
                                </div>
                                <div>
                                    <span class="s-c-heading">Valid To
                                        <span class="p-l-5 col-grey-light cur-pointer" nz-tooltip
                                            nzTooltipTitle="The expiry date marks the point from which the rule will no longer be applicable. It helps manage rule validity and ensures that outdated rules are not enforced.">
                                            <i nz-icon nzType="exclamation-circle" class="ico-item"></i>
                                        </span>
                                    </span>
                                    {{item.toDate ? (convertTimestampToRegular(item.toDate) | date: appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR) : '-'}}
                                </div>
                                <!--  -->
                                <div>
                                    <span class="s-c-heading">Overridden Rule</span>
                                    {{(item.baseRule) || '-'}}
                                </div>
                                <div *ngIf="item.category">
                                    <span class="s-c-heading">Rule Priority</span>
                                    {{(item.category | technicalTranslate) || '-'}}
                                </div>
                                <!-- <div *ngIf="item.decisionType">
                                    <span class="s-c-heading">Decision Type
                                        <span class="p-l-5 col-grey-light cur-pointer" nz-tooltip
                                            nzTooltipTitle="The description field provides a clear and detailed explanation of the rule. It helps in understanding the purpose, logic, and conditions of the rule.">
                                            <i nz-icon nzType="exclamation-circle" class="ico-item"></i>
                                        </span>
                                    </span>
                                    {{(item.decisionType | technicalTranslate) || '-'}}
                                </div> -->
                                <div *ngIf="item.ruleProcessingType">
                                <span class="s-c-heading">Processing Type
                                    <span class="p-l-5 col-grey-light cur-pointer" nz-tooltip nzTooltipTitle="Click to view details"
                                        (click)="showDetailedDesc('Processing Type' , fieldDescriptions['ruleProccessingType'])">
                                        <i nz-icon nzType="question-circle" class="ico-item"></i>
                                    </span>
                                </span>
                                    {{(item.ruleProcessingType | technicalTranslate) || '-'}}
                                </div>
                                <div *ngIf="item.preConditionRuleCSV && selectedPreConditionRule && selectedPreConditionRule.displayName">
                                    <span class="s-c-heading">Pre-condition Rule</span>
                                    {{selectedPreConditionRule.displayName || '-'}}
                                </div>
                                <!--  -->
                                <div style="grid-column: 1/4;">
                                    <span class="s-c-heading">Rule Description
                                        <span class="p-l-5 col-grey-light cur-pointer" nz-tooltip
                                            nzTooltipTitle="The description field provides a clear and detailed explanation of the rule. It helps in understanding the purpose, logic, and conditions of the rule.">
                                            <i nz-icon nzType="exclamation-circle" class="ico-item"></i>
                                        </span>
                                    </span>
                                    {{(item.ruleDesc) || '-'}}
                                </div>
                                <!--  -->
                            </div>
                
                            <!-- <div><span class="s-c-heading">Rule Entity</span>{{item.ruleEntity | technicalTranslate}}</div> -->
                            <!-- <div>
                                            <span class="s-c-heading">Rule Sub Type</span>
                                            {{(item.ruleSubType | technicalTranslate) || '-'}}
                                        </div> -->
                
                
                
                            <!-- <div>
                                            <span class="s-c-heading">Rule Set Type</span>
                                            {{(item.ruleSetType | technicalTranslate) || '-'}}
                                        </div> -->
                        </div>
                        <nz-divider *ngIf="!lastItem"></nz-divider>
                    </div>
                </ng-container>



                

                <!-- User's comments -->
                <div class="user-revision-comment m-t-20" *ngIf="viewAuditRuleArr && viewAuditRuleArr.length && false">
                    <span class="s-c-heading">Version remark by <strong>{{selectedItem.user}}</strong></span>
                    {{selectedItem.remarks}}
                </div>
                <!-- TABS for rule details / tables -->
                <div (click)="isDTRulesSectionCollapsed = !isDTRulesSectionCollapsed" class="audit-info-tabs m-t-20" *ngIf="viewRuleArr && viewRuleArr.length && !isComputationRule && ruleRowsList && ruleRowsList.length > 0">
                    <h2 class="heading-mms" style="background: #f6f6f6;
                        padding: 10px;">
                            <span class="p-r-10" nz-icon nzType="down-circle" [nzSize]="'default'" [nzRotate]="isDTRulesSectionCollapsed ? 180 : 0"></span>Rule Data </h2>
                </div>

                <div *ngIf="!isDTRulesSectionCollapsed" class="pos-relative">

                    <!-- Heading -->
                    <!-- <h3 *ngIf="heading" class="d-i-b f-s-1-2r t-transform heading-table">{{heading}}</h3>
                    <h3 class="d-i-b f-s-1-2r t-transform" [ngClass]="{'heading-table': ruleRowsList && ruleRowsList.length > 0}">Rule Data</h3> -->
                    <!-- Rule Data Table -->
                    <div *ngIf="ruleRowsList && ruleRowsList.length > 0 && viewRuleArr[0]?.ruleCategory !='COMPUTATIONMODEL'" class="apply-tableLayout-auto">
                    <nz-table #ruleDataTable [nzData]="ruleRowsList"
                        [nzScroll]="{x:(noOfConditions.length>=1 || noOfActions.length>=1)?'900px':null,y:null}"
                        (nzPageIndexChange)="pageChange($event)" [nzFrontPagination]="ruleRowsList.length > 10 ? true : false"
                        [nzPaginationPosition]="'bottom'" nzSize="small" [nzBordered]="true" [nzPageSize]="10">
                        <thead>
                            <!-- Header: Category -->
                            <tr>
                                <th scope="col" style="max-width:50px">
                                    <span class="grid-head-conditions">Sr No.</span>
                                </th>
                                <!-- colspan below must be computed based on conditions.length -->
                                <th scope="col" *ngIf="noOfConditions && noOfConditions.length > 0" [attr.colspan]="noOfConditions.length">
                                    <span class="grid-head-conditions">Conditions</span>
                                </th>
                                <!-- colspan below must be computed based on actions.length -->
                                <th scope="col" *ngIf="noOfActions && noOfActions.length > 0" [attr.colspan]="noOfActions.length">
                                    <span class="grid-head-actions">Actions</span>
                                </th>
                            </tr>
                            <!-- Header -->
                            <tr>
                                <th scope="col" style="max-width: 50px">
                                    <!--S.no-->
                                </th>
                                <!--  Conditions and Actions header -->
                                <ng-container *ngFor="let condition of noOfConditions">
                                    <th scope="col" style="min-width:180px;">
                                        <div class="flex">
                                            <!-- <span class="m-r-5">{{getRuleConditionName(condition, condition.columnData)}}</span> -->
                                            <span class="m-r-5">{{ getConditionDisplayName(condition,condition.columnData) }}</span>

                                            <!-- <i nz-icon class="cur-pointer f-s-16p"
                                                *ngIf="condition && condition.dataTypeCd && (condition.dataTypeCd?.includes('expression') || condition.dataTypeCd.includes('forLoop'))"
                                                nzType="eye" nzTheme="outline" (click)="showExpressionDataInModal(condition)"></i> -->
                                            <code class="expr" nz-popover nzPopoverTitle="Expression" [nzPopoverContent]="expressionTemplate"
                                                nzPopoverPlacement="bottom">
                                                    <i *ngIf="condition?.expressionUiCondition" nz-icon nzType="eye" nzTheme="outline"></i>
                                            </code>
                                        
                                            <!-- give nz-tooltip here  -->
                                            <ng-template #expressionTemplate>
                                                <!-- <div style="width:500px; overflow-y: scroll; background-color: #f5f5f5; border-radius: 5px; white-space: pre-wrap; word-break: break-all"> -->
                                                    <!-- {{selCondition?.expressionUiCondition}} -->
                                                    <!-- {{expressionInnerHTMLWithDescription(condition?.expressionUiCondition,condition.dataTypeCd)}} -->
                                                <!-- </div> -->
                                                <div style="width:500px; overflow-y: scroll; background-color: #f5f5f5; border-radius: 5px; white-space: pre-wrap; word-break: break-all">
                                                    <!-- {{selCondition?.expressionUiCondition}} -->
                                                   <div [innerHTML]="expressionInnerHTMLWithDescription(condition?.expressionUiCondition,condition.dataTypeCd)"></div>
                                                </div>
                                            </ng-template>
                                        </div>
                                        <small *ngIf="condition.dataTypeCd &&  !(condition.dataTypeCd.includes('from') ||  condition.dataTypeCd.includes('to'))"
                                                 class="d-b grid-head-conditions">Operator: {{condition.dataTypeCd | technicalTranslate}}</small>
                                        <small *ngIf="(condition.dataTypeCd | rangeFilter : 'from' )" class="d-b grid-head-conditions">Range: From</small>
                                        <small *ngIf="(condition.dataTypeCd | rangeFilter : 'to')" class="d-b grid-head-conditions">Range: To</small>
                                    </th>
                                </ng-container>
                                <ng-container *ngFor="let action of noOfActions">
                                    <th scope="col" style="min-width:180px;"  *ngIf="action.columnData">
                                        <!-- {{action.columnData | technicalTranslate}} -->
                                        <span class="m-r-5">{{ getActionDisplayName(action)}}</span>
                                        <!-- <small class="d-b grid-head-actions">{{action.dataTypeCd |
                                            technicalTranslate}}</small> -->
                                    </th>
                                </ng-container>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- conditions and actions data in rule Data  -->
                            <tr *ngFor="let ruleRow of ruleDataTable.data; let i=index;">
                                <ng-container
                                    *ngIf="ruleRow.ruleColumnsList && ruleRow.ruleColumnsList.length && ruleRow.ruleColumnsList.length>0">
                                    <td class="text-a-center">{{i+1}}</td>
                                    <ng-container *ngFor="let ruleColumn of ruleRow.ruleColumnsList; let i=index;">
                                        <td  *ngIf="ruleColumn.columnData" [class.icd-max-width]="ruleColumn.columnData=='ICDCategory'"
                                            [class.text-a-right]="ruleColumn.align=='right'"
                                            [class.text-a-left]="ruleColumn.align=='left'">
                                            <span  *ngIf="(attributeMap[ruleColumn.columnData] && attributeMap[ruleColumn.columnData].dataTypeCd == 'COMBO') ||
                                                        ruleColumn['labelType'] == 'LOOKUP';
                                                        else otherTranslate">
                                                {{ruleColumn.data | technicalTranslate}}
                                            </span>
                                            <ng-template #otherTranslate>
                                                <ng-container *ngIf="(attributeMap[ruleColumn.columnData] && attributeMap[ruleColumn.columnData].dataTypeCd == 'RICHTEXT'); else withoutTranslate">
                                                    {{ruleColumn.data | convertExpressionCodeToName}}
                                                    <!-- <pre>{{'{#VC_TreatmentMethod} allows to {ss} into {#VC_PastHistoryDetailsHistoricalClaimHospitalisation} .' | convertExpressionCodeToName }}</pre> -->
                                                </ng-container>
                                                <ng-template #withoutTranslate>
                                                    {{ruleColumn.data}}
                                                </ng-template>
                                            </ng-template>
                                        </td>
                                    </ng-container>
                                </ng-container>
                            </tr>
                        </tbody>
                    </nz-table>
                    </div>

                </div>
                
                <div *ngIf="!isComputationStepSectionCollapsed && isComputationRule" style="margin: 10px 0;
                                                                text-align: end;
                                                                display: grid;">
                    <label>Preview Data</label>
                    <nz-switch [(ngModel)]="dataTransformService.expressionQuickView"></nz-switch>
                </div>
                <div *ngIf="isComputationRule" (click)="isComputationStepSectionCollapsed = !isComputationStepSectionCollapsed">
                    <h2 class="heading-mms" style="background: #f6f6f6;
                                                        padding: 10px;">
                        <span class="p-r-10" nz-icon nzType="down-circle" [nzSize]="'default'"
                            [nzRotate]="isComputationStepSectionCollapsed ? 180 : 0"></span>Computation Steps Details
                    </h2>
                    <div *ngIf="!isComputationStepSectionCollapsed">
                        <div *ngIf="isComputationRule">
                
                            <nz-collapse class="collapse-overflow" [nzBordered]="false">
                
                                <ng-container *ngFor="let step of computationalRules;let i=index;">
                                    <nz-collapse-panel [nzHeader]="expandedIcon" [nzActive]="step.expand" (click)="preventDefault($event)">
                                        <div class="heading-tab" style="margin-bottom: -1px" *ngIf="false">
                                            <div class="flex">
                                                <h3 class="heading">
                                                    <!-- <i nz-icon nzType="profile"></i>  -->
                                                    STEP #{{i+1}}
                                                    <!-- <span class="col-grey-dark">{{step.ruleName}}</span> -->
                                                </h3>
                                                <div>
                                                    <nz-tag *ngIf="step.step_type" [nzColor]="'blue'"
                                                        style="margin-left: 10px !important;">
                                                        {{step.step_type | technicalTranslate}}</nz-tag>
                                                    <ng-container
                                                        *ngIf="dataTransformService.expressionQuickView && step.step_type=='EXPRESSIONEVALUATION' && !step.isexpanded && (expressionHTMLText && expressionHTMLText.length>1)"
                                                        class="view-expression-container">
                                                        <div class="sub-container">
                                                            <div class="m-l-10 f-w-400"
                                                                [innerHTML]="expressionHTMLText"></div>
                                                        </div>
                                                    </ng-container>
                                                    <ng-container
                                                        *ngIf="dataTransformService.expressionQuickView && step.step_type=='DTEVALUATION' && !step.isexpanded"
                                                        class="view-expression-container">
                                                        <div class="sub-container">
                                                            <div class="m-l-10 f-w-400"
                                                                style="font-family: Consolas, monospace !important;">
                                                                <span>
                                                                    {{(step.ruleDataList[0].action1 | technicalTranslate) || '-'}}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </div>
                
                                            </div>
                                            <div>
                                                <!-- IMP: The confirmation title should be a variable as in proto below: -->
                                            </div>
                                        </div>
                
                                        <!-- New desing -->
                                        <ng-template #expandedIcon let-active [ngStyle]="panelCustomStyle"
                                            nzExpandedIcon="panelIcon||undefined">
                                            <div class="rule-audit-heading-tab panel-custom-unified-collapse-heading"
                                                style="margin-bottom: -1px">
                                                <div class="flex" style="
                                                                        align-self: flex-start">
                                                    <h3 class="heading" style="width: 100px;
                                                                            align-self: flex-start">
                                                        <!-- <i nz-icon nzType="profile"></i> -->
                                                        STEP #{{i+1}}
                                                        <!-- <span
                                                                                class="col-grey-dark">{{step.ruleName}}</span> -->
                                                    </h3>
                                                    <!-- <nz-tag *ngIf="step.step_type" [nzColor]="'blue'" style="margin-left: 10px !important;">
                                                                                {{step.step_type | technicalTranslate}}</nz-tag> -->
                                                </div>
                                                <div>
                                                    <div style="display: flex;">
                                                        <div>
                                                          <nz-tag *ngIf="step.step_type" [nzColor]="'blue'" style="margin-left: 10px !important;">
                                                            {{step.step_type | technicalTranslate}}</nz-tag>
                                                        </div>
                                                        <div [hidden]="privilege && privilege == 'VIEW' && step.ruleDesc == null">
                                                            <span *ngIf="step.ruleDesc"  nz-tooltip  [nzTooltipTitle]="step.ruleDesc"><i>{{step.ruleDesc}}</i></span>
                                                        </div>
                                                    </div>
                                                    <ng-container
                                                        *ngIf="dataTransformService.expressionQuickView && step.step_type=='EXPRESSIONEVALUATION' && !step.isexpanded && (expressionHTMLText && expressionHTMLText.length>1)"
                                                        class="view-expression-container">
                                                        <div class="sub-container">
                                                            <div class="m-l-10 f-w-400"
                                                                [innerHTML]="expressionHTMLText"></div>
                                                        </div>
                                                    </ng-container>
                                                    <ng-container *ngIf="dataTransformService.expressionQuickView && step.step_type=='DTEVALUATION' && !step.isexpanded"
                                                        class="view-expression-container">
                                                        <div class="sub-container">
                                                            <div class="m-l-10 f-w-400" style="font-family: Consolas, monospace !important;">
                                                                <span>
                                                                    {{(step.ruleDataList[0].action1 | technicalTranslate) || '-'}}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </ng-template>
                
                
                
                                        <!-- <app-computional-step-component></app-computional-step-component> -->
                                        <div *ngIf="false" class="grid grid-1x grid-gap-20 p-t-5 p-l-r-40">
                
                                            <div class="grid-step">
                                                <label>Step Type</label>
                                                <nz-radio-group [(ngModel)]="step.step_type" nzSize="small" nzName="step_type"
                                                    [nzButtonStyle]="'solid'" (ngModelChange)="pseudoLoad(100000)" nzDisabled="'true'">
                                                    <label nz-radio-button
                                                        *ngFor="let item of (lookup$['computationStepType'] | async) as computationStepTypeLookup; trackBy:item?.lookupKey"
                                                        [nzValue]="item?.lookupKey"> {{item?.lookupValue}}
                                                    </label>
                                                </nz-radio-group>
                                            </div>
                
                                            <div class="grid-step">
                                                <label>Step Variable</label>
                                                <nz-radio-group [(ngModel)]="step.radio_select" nzSize="small" nzName="StepVariable"
                                                    [nzButtonStyle]="'solid'" nzDisabled="'true'">
                                                    <label nz-radio-button
                                                        *ngFor="let item of (lookup$['StepVariable'] | async) as StepVariableLookup; trackBy:item?.lookupKey"
                                                        [nzValue]="item?.lookupKey"> {{item?.lookupValue}}
                                                    </label>
                                                </nz-radio-group>
                
                                            </div>
                
                
                                            <div class="grid-step">
                                                <label></label>
                                                <div *ngIf="commonUtilty.isArrayIterable(step.ruleActionList)" nzDisabled="'true'">
                                                    <div *ngIf="step.radio_select=='VARIABLE'">
                                                        <code class="bg-grey-light p-10">
                                                                                      {{step.ruleActionList[0].action}}
                                                                                    </code>
                                                    </div>
                                                    <div *ngIf="step.radio_select=='VOCABULARY'">
                                                        <!-- IMP: Do not miss out on properties like nzShowSearch & style during implementation -->
                                                        <nz-select nzShowSearch [(ngModel)]="step.ruleActionList[0].action"
                                                            (ngModelChange)="reloadExpBuilder()" style="width: 100%;max-width: 500px"
                                                            nzDisabled="'true'">
                                                            <!-- <nz-option
                                                                                        *ngFor="let item of (lookup$['comboVocabularyCd'] | async) as comboVocabularyCdLookup; trackBy:item?.lookupKey"
                                                                                        [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey">
                                                                                      </nz-option> -->
                                                            <nz-option *ngFor="let item of allVocabularies; trackBy:item?.entityCd"
                                                                [nzLabel]="item?.entity" [nzValue]="item?.entityCd">
                                                            </nz-option>
                                                        </nz-select>
                
                
                                                    </div>
                                                </div>
                                            </div>
                
                                            <div class="grid-step">
                                                <ng-container
                                                    *ngIf="step.step_type=='ASSIGNMENT' && commonUtilty.isArrayIterable(step.ruleDataList)">
                                                    <label>Assign to</label>
                                                    <div>
                                                        <!-- IMP: Do not miss out on properties like nzShowSearch & style during implementation  assignment-->
                                                        <nz-select nzShowSearch [(ngModel)]="step.ruleDataList[0].action1"
                                                            style="width: 100%;max-width: 500px" nzDisabled="'true'">
                                                            <nz-option
                                                                *ngFor="let item of (lookup$['comboVocabularyCd'] | async) as comboVocabularyCdLookup; trackBy:item?.lookupKey"
                                                                [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey">
                                                            </nz-option>
                                                        </nz-select>
                                                    </div>
                                                </ng-container>
                
                                                <ng-container
                                                    *ngIf="step.step_type=='EXPRESSIONEVALUATION' && commonUtilty.isArrayIterable(step.ruleDataList)">
                                                    <label>Expression</label>
                                                    <div
                                                        *ngIf="(step.radio_select && (step.radio_select=='VARIABLE') || (( step.radio_select=='VOCABULARY' && commonUtilty.isArrayIterable(step.ruleActionList) &&  step.ruleActionList[0].action) ))">
                                                        <!-- <code *ngIf="step.ruleDataList[0].expressionUiAction"
                                                                                      class="bg-grey-light p-10">{{step.ruleDataList[0].expressionUiAction ? step.ruleDataList[0].expressionUiAction !='null'? step.ruleDataList[0].expressionUiAction : '':'' }}</code> -->
                                                        <div *ngIf="!appMetadataHandler.featureFlags.buildExpressionInsideSteps"
                                                            class="p-t-b-10">
                                                            <button (click)="setCurrentExpressionAndOpenModal(step)" nz-button
                                                                nzSize="small" nzType="link">Build
                                                                Expression</button>
                                                        </div>
                
                                                        <!-- Expression builder modal -->
                                                        <div>
                
                                                            <app-pc-expression-container
                                                                *ngIf="appMetadataHandler.featureFlags.buildExpressionInsideSteps"
                                                                [disableEdit]="'true'" [class.inputs-are-disabled]="'true'"
                                                                mode="expression" [currentVocabulary]="getLookupCdForStep(step)"
                                                                [(ngModel)]="step.ruleDataList[0].expressionUiAction"
                                                                (ngModelChange)="setRuleDataActionForExpression($event,step)"
                                                                [controlType]="step.ruleActionList[0].actionType || 'expression' "
                                                                (currentControlType)="setCurrentControlType($event,step)"
                                                                (emittedExpression)="getEmittedExpression($event)">
                                                            </app-pc-expression-container>
                
                                                        </div>
                
                                                    </div>
                                                </ng-container>
                
                                                <ng-container
                                                    *ngIf="step.step_type=='DTEVALUATION' && commonUtilty.isArrayIterable(step.ruleDataList)">
                                                    <label>Rule Name</label>
                                                    <!-- IMP: Do not miss out on properties like nzShowSearch & style during implementation  DT-->
                                                    <nz-select nzShowSearch [(ngModel)]="step.ruleDataList[0].action1"
                                                        style="width: 100%;max-width: 500px">
                                                        <nz-option
                                                            *ngFor="let item of payoutRateLookupList as payoutRateTableCdLookup; trackBy:item?.lookupKey"
                                                            [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey">
                                                        </nz-option>
                                                    </nz-select>
                                                </ng-container>
                
                                                <ng-container *ngIf="step.step_type=='QUESTIONNAIRE'">
                                                    <label>Questionnaire</label>
                                                    <div>
                                                        <!-- IMP: Do not miss out on properties like nzShowSearch & style during implementation -->
                                                        <nz-select nzShowSearch [ngModel]="'1'" style="width: 100%;max-width: 500px">
                                                            <nz-option nzValue="1" nzLabel="Health Questionnaire: Basic / Pre-Existing">
                                                            </nz-option>
                                                            <nz-option nzValue="2"
                                                                nzLabel="Health Questionnaire: Terminal / Family History">
                                                            </nz-option>
                                                        </nz-select>
                                                    </div>
                                                </ng-container>
                
                                            </div>
                
                                        </div>
                                        <div class="grid grid-3x grid-3x-responsive">
                                            <div>
                                                <span class="s-c-heading">Step Type</span>
                                                {{(step.step_type | technicalTranslate) || '-'}}
                                            </div>
                                            <div>
                                                <div class="flex">
                                                    <span class="s-c-heading">Step Variable</span>
                                                    <nz-tag *ngIf="step.radio_select == ''" [nzColor]="'blue'"
                                                        style="margin-left: 10px !important;height : fit-content">
                                                        {{step.radio_select | technicalTranslate}}</nz-tag>
                                                </div>
                                                <!-- {{(step.ruleActionList[0].action | technicalTranslate) ||'-'}} -->

                                                <span *ngIf="commonUtilty.isArrayIterable(step.ruleActionList)"
                                                    nzDisabled="'true'">{{getComputationRuleDisplayName(step.ruleActionList[0].action) ||
                                                    '-'}}</span>
                                            </div>
                                            <div
                                                *ngIf="step.step_type=='ASSIGNMENT' && commonUtilty.isArrayIterable(step.ruleDataList)">
                                                <span class="s-c-heading">Assign to</span>
                                                <span *ngIf="commonUtilty.isArrayIterable(step.ruleActionList)"
                                                    nzDisabled="'true'">{{(step.ruleDataList[0].action1 | technicalTranslate) ||
                                                    '-'}}</span>
                                            </div>
                                            <div
                                                *ngIf="step.step_type=='DTEVALUATION' && commonUtilty.isArrayIterable(step.ruleDataList)">
                                                <span class="s-c-heading">Rule Name</span>
                                                <a (click)="fetchRuleName(step.ruleDataList[0].action1,step.ruleDataList[0].versionId)">{{(step.ruleDataList[0].action1 | technicalTranslate) || '-'}}</a>                                            
                                            </div>
                
                                            <ng-container *ngIf="step.step_type=='QUESTIONNAIRE'">
                                                <span class="s-c-heading">Questionnaire</span>
                                                <div>
                                                    <!-- IMP: Do not miss out on properties like nzShowSearch & style during implementation -->
                                                    <nz-select nzShowSearch [ngModel]="'1'" style="width: 100%;max-width: 500px">
                                                        <nz-option nzValue="1" nzLabel="Health Questionnaire: Basic / Pre-Existing">
                                                        </nz-option>
                                                        <nz-option nzValue="2"
                                                            nzLabel="Health Questionnaire: Terminal / Family History">
                                                        </nz-option>
                                                    </nz-select>
                                                </div>
                                            </ng-container>
                                        </div>
                                        <div class="grid-step m-t-20">
                                            <ng-container
                                                *ngIf="step.step_type=='EXPRESSIONEVALUATION' && commonUtilty.isArrayIterable(step.ruleDataList)">
                                                <label>Expression</label>
                                                <div
                                                    *ngIf="(step.radio_select && (step.radio_select=='VARIABLE') || (( step.radio_select=='VOCABULARY' && commonUtilty.isArrayIterable(step.ruleActionList) &&  step.ruleActionList[0].action) ))">
                                                    <!-- <code *ngIf="step.ruleDataList[0].expressionUiAction"
                                                                                  class="bg-grey-light p-10">{{step.ruleDataList[0].expressionUiAction ? step.ruleDataList[0].expressionUiAction !='null'? step.ruleDataList[0].expressionUiAction : '':'' }}</code> -->
                                                    <div *ngIf="!appMetadataHandler.featureFlags.buildExpressionInsideSteps"
                                                        class="p-t-b-10">
                                                        <button (click)="setCurrentExpressionAndOpenModal(step)" nz-button
                                                            nzSize="small" nzType="link">Build
                                                            Expression</button>
                                                    </div>
                
                                                    <!-- Expression builder modal -->
                                                    <div>
                
                                                        <app-pc-expression-container
                                                            *ngIf="appMetadataHandler.featureFlags.buildExpressionInsideSteps"
                                                            [disableEdit]="'true'" [class.inputs-are-disabled]="'true'"
                                                            mode="expression" [currentVocabulary]="getLookupCdForStep(step)"
                                                            [(ngModel)]="step.ruleDataList[0].expressionUiAction"
                                                            (ngModelChange)="setRuleDataActionForExpression($event,step)"
                                                            [controlType]="step.ruleActionList[0].actionType || 'expression' "
                                                            (currentControlType)="setCurrentControlType($event,step)"
                                                            (emittedExpression)="getEmittedExpression($event)">
                                                        </app-pc-expression-container>
                
                                                    </div>
                
                                                </div>
                                            </ng-container>
                                        </div>
                                    </nz-collapse-panel>
                                </ng-container>
                            </nz-collapse>
                
                        </div>
                    </div>
                </div>

                <div class="audit-info-tabs m-t-20" *ngIf="ruleContext && ruleContext.length && (showDetails === true || showDetails === undefined)">
                    <h2 class="heading-mms" style="background: #f6f6f6;
                        padding: 10px;">
                            <span class="p-r-10" nz-icon nzType="down-circle" [nzSize]="'default'" [nzRotate]="isApplicableContextSectionCollapsed ? 180 : 0" (click)="isApplicableContextSectionCollapsed = !isApplicableContextSectionCollapsed"></span>Applicable Context</h2>
                    <div *ngIf="!isApplicableContextSectionCollapsed" class="pos-relative">

                        <!-- Heading -->
                        <!-- <h3 *ngIf="heading" class="d-i-b f-s-1-2r t-transform heading-table">{{heading}}</h3>
                        <h3 class="d-i-b f-s-1-2r t-transform heading-table">Applicable Context</h3> -->

                        <!-- Rule Data Table -->
                        <nz-table #ruleContextTable [nzData]="ruleContext" (nzPageIndexChange)="pageChange($event)"
                            [nzFrontPagination]="ruleContext.length > 10 ? true : false" [nzPaginationPosition]="'bottom'" nzSize="small"
                            [nzBordered]="true" [nzPageSize]="10">
                            <thead>
                                <!-- Header -->
                                <tr>
                                    <th scope="col" style="width: 60px;">Sr No.</th>
                                    <th scope="col">Context</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let context of ruleContextTable.data; let i=index;">
                                    <tr>
                                        <td class="text-a-center">{{i+1}}</td>
                                        <td class="text-a-left">
                                            <span>{{context | technicalTranslate}}</span>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </nz-table>

                    </div>

                </div>
            </div>
        </nz-spin>
    </div>
</div>


<nz-modal [(nzVisible)]="ShowExpressionBuilderViewModal" [nzTitle]="'Expression Builder'" nzClosable [nzMaskClosable]="false"
  nzCancelText="Close" [nzOkText]="null" [nzZIndex]="1002" (nzOnCancel)="ShowExpressionBuilderViewModal=false" nzWidth="860px" >
  <ng-container *nzModalContent>
  <ng-container *ngIf="ShowExpressionBuilderViewModal">
    <app-pc-expression-container  [disableEdit]="'true'" [class.inputs-are-disabled]="'true'"
        mode="expression" [currentVocabulary]="currentVocabulary"  
        [(ngModel)]="expressionBuilderViewObj.columnData" 
        [controlType]="expressionBuilderViewObj.dataTypeCd"  
        (currentControlType)="expressionBuilderViewObj.dataTypeCd  = $event"
        (emittedExpression)="getEmittedExpression($event)"> 
    </app-pc-expression-container>
  </ng-container>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="showDetailedDescModal" [nzTitle]="selectedField['fieldName']" nzWidth="50vw"
(nzOnCancel)="showDetailedDescModal = false;" [nzOkText]="null" [nzZIndex]="1001" nzCancelText="Close" >
<ng-container *nzModalContent>
  <div [innerHtml]="selectedField['detailedDesc']"></div>
</ng-container>
</nz-modal>